import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';
import RoundedButton from 'components/Shared/RoundedButton';
import { ALL_ROUTES } from 'config/routes';
import { useSelector, useDispatch } from 'react-redux';
import { navigateToRoute, selectBreadcrumbs } from '../../redux_store';

const useStyles = makeStyles((theme) => ({
  marginRight16: {
    marginRight: theme.spacing(2),
  },
}));

// set route: either previous bc if exist or root path
const BackButton = ({ className, rightMargin, ...props }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { en: { btn } } = useSelector((state) => state.i18n);
  const breadcrumbs = useSelector(selectBreadcrumbs) || [];
  const lastBc = breadcrumbs.length > 1 && breadcrumbs[breadcrumbs.length - 2];

  const handleClick = () => {
    dispatch(navigateToRoute({
      route: lastBc || { path: ALL_ROUTES.root.path }
    }));
  };

  return (
    <RoundedButton
      color='primary'
      variant='outlined'
      size='small'
      className={cx(className, {
        [classes.marginRight16]: rightMargin,
      })}
      onClick={handleClick}
      {...props}
    >
      {btn.cancel}
    </RoundedButton>
  );
};

BackButton.propTypes = {
  className: PropTypes.string,
  rightMargin: PropTypes.bool,
};

BackButton.defaultProps = {
  className: undefined,
  rightMargin: true,
};

export default BackButton;
